<template>
  <div class="date-range-filter" data-testid="date-range-filter">
    <!-- Selection progress indicator -->
    <div
      class="date-range-filter__progress"
      :class="{
        'date-range-filter__progress--selecting': localRange.length === 1,
        'date-range-filter__progress--complete': localRange.length === 2,
      }"
      data-testid="date-range-filter__progress"
    >
      <div class="date-range-filter__progress-node" :class="{ 'is-active': localRange.length >= 1 }">
        <span class="date-range-filter__progress-dot"></span>
        <span class="date-range-filter__progress-label">
          {{ localRange.length >= 1 ? formatDate(sortedRange[0]) : 'Start date' }}
        </span>
      </div>
      <div class="date-range-filter__progress-track">
        <div class="date-range-filter__progress-fill"></div>
      </div>
      <div class="date-range-filter__progress-node" :class="{ 'is-active': localRange.length === 2 }">
        <span class="date-range-filter__progress-dot"></span>
        <span class="date-range-filter__progress-label">
          {{ localRange.length === 2 ? formatDate(sortedRange[1]) : 'End date' }}
        </span>
      </div>
    </div>
    <v-date-picker
      v-model="localRange"
      range
      no-title
      color="primary"
      class="elevation-0 date-range-filter__picker"
      data-testid="date-range-filter__picker"
    />
    <v-divider data-testid="date-range-filter__divider" />
    <div class="date-range-filter__footer px-3 py-2 d-flex align-center justify-end" data-testid="date-range-filter__footer">
      <v-btn
        text
        small
        @click="onClear"
        data-testid="date-range-filter__clear-btn"
        class="mr-1"
      >
        <span>Clear</span>
      </v-btn>
      <v-btn
        color="primary"
        small
        depressed
        @click="onApply"
        :disabled="localRange.length === 0"
        data-testid="date-range-filter__apply-btn"
      >
        <span>Apply</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import './DateRangeFilter.scss';

export default {
  name: 'DateRangeFilter',
  props: {
    value: {
      type: Object,
      default: () => ({ from: null, to: null }),
    },
  },
  data() {
    return {
      localRange: [],
    };
  },
  computed: {
    sortedRange() {
      return this.localRange.slice().sort();
    },
    summaryText() {
      const sorted = this.sortedRange;
      if (sorted.length === 2) return `${this.formatDate(sorted[0])}  —  ${this.formatDate(sorted[1])}`;
      if (sorted.length === 1) return `${this.formatDate(sorted[0])}  — ...`;
      return 'Select a date range';
    },
  },
  watch: {
    value: {
      handler(val) {
        this.initFromValue(val);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    formatDate(isoDate) {
      if (!isoDate) return '';
      const [year, month, day] = isoDate.split('-');
      return `${day}/${month}/${year}`;
    },
    initFromValue(val) {
      if (val && val.from && val.to) {
        this.localRange = [val.from, val.to];
      } else if (val && val.from) {
        this.localRange = [val.from];
      } else {
        this.localRange = [];
      }
    },
    onApply() {
      const sorted = this.sortedRange;
      if (sorted.length >= 2) {
        this.$emit('apply', { from: sorted[0], to: sorted[1] });
      } else if (sorted.length === 1) {
        // Single date selected: use same date as both from and to
        this.$emit('apply', { from: sorted[0], to: sorted[0] });
      }
    },
    onClear() {
      this.localRange = [];
      this.$emit('apply', null);
    }
  },
};
</script>
